import React, {useEffect, useMemo, useReducer, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import {useSearchParams} from 'react-router-dom'
import useQueryReferral from '../../../hooks/api/cashback/useQueryReferral'
import useQueryExchanges from '../../../hooks/etc/useQueryExchanges'
import Text from '../../../components/text/Text'
import UnderLineInput from '../../../components/input/UnderLineInput'
import WizImage from '../../../components/image/WizImage'
import WizButton from '../../../components/button/WizButton'
import {editReferral} from '../../../apis/cashback/editReferral'
import useNavigation from '../../../hooks/useNavigation'
import WizSelectButton from '../../../components/button/WizSelectButton'

interface IProps {
    className?: string
}

const initState = {
    exchange_maker_fee_rate: 0,
    exchange_taker_fee_rate: 0,
    max_reward_rate: 0,
    referral_code: '',
}
const ReferralDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const queryId = searchParams.get('exchange')

    const {data} = useQueryReferral(queryId)
    const {data: exchanges} = useQueryExchanges()

    const me = exchanges?.find(exchange => {
        if (exchange?.name === 'okex' && queryId === 'okx') {
            return true
        }

        return exchange?.name === queryId
    })
    const {goPayback} = useNavigation()

    const [state, dispatch] = useReducer(reducer, initState)

    const {exchange_maker_fee_rate, exchange_taker_fee_rate, max_reward_rate, referral_code} = state

    function reducer(state, action) {
        switch (action.type) {
            case 'field_reset':
                return {
                    exchange_maker_fee_rate: data?.data?.exchange_maker_fee_rate,
                    exchange_taker_fee_rate: data?.data?.exchange_taker_fee_rate,
                    max_reward_rate: data?.data?.max_reward_rate,
                    referral_code: data?.data?.referral_code,
                }
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    const statusList = useMemo(
        () => [
            {id: 0, value: 'Hide'},
            {id: 1, value: 'Show'},
        ],
        [],
    )

    const [referralStatus, setReferralStatus] = useState(statusList[0])

    useEffect(() => {
        dispatch({
            type: 'field_reset',
        })
        setReferralStatus(statusList[data?.data?.status ?? 0])
    }, [data?.data])

    return (
        <PageLayout title={`${me?.display_name} Referral Detail`} className={`space-y-[30px] ${className}`}>
            <section
                className={
                    'w-[1000px] bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[80px] lg:w-[900px] md:w-[560px] md:px-[20px] md:text-center sm:block sm:w-full sm:space-y-[30px]'
                }>
                <div className={'grid grid-cols-2 gap-x-[40px] gap-y-[40px] '}>
                    <div className={'col-span-2 text-center'}>
                        <Text className={'text-body3 text-font02'}>Exchange</Text>
                        <div className={'flex items-center gap-[10px] justify-center'}>
                            <WizImage src={me?.icon} className={'w-[24px]'} />
                            <Text className={'text-h3'}>{me?.display_name}</Text>
                        </div>
                    </div>
                    <div className={''}>
                        <Text className={'text-body3 text-font02'}>Cashback % (페이백율 %)</Text>
                        <UnderLineInput
                            inputClassName={'md:text-center'}
                            value={max_reward_rate}
                            onChanged={text =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'max_reward_rate',
                                    value: Number(text),
                                })
                            }
                        />
                    </div>
                    <div className={''}>
                        <Text className={'text-body3 text-font02'}>Limit Order Fee (지정가 수수료)</Text>
                        <UnderLineInput
                            inputClassName={'md:text-center'}
                            value={exchange_maker_fee_rate}
                            onChanged={text =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'exchange_maker_fee_rate',
                                    value: Number(text),
                                })
                            }
                        />
                    </div>
                    <div className={''}>
                        <Text className={'text-body3 text-font02'}>Market Commission (시장가 수수료)</Text>
                        <UnderLineInput
                            inputClassName={'md:text-center'}
                            value={exchange_taker_fee_rate}
                            onChanged={text =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'exchange_taker_fee_rate',
                                    value: Number(text),
                                })
                            }
                        />
                    </div>
                    <div className={''}>
                        <Text className={'text-body3 text-font02'}>Referral Code</Text>
                        <UnderLineInput
                            inputClassName={'md:text-center'}
                            value={referral_code}
                            onChanged={text =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'referral_code',
                                    value: text,
                                })
                            }
                        />
                    </div>
                    <div className={'col-span-2 text-center'}>
                        <Text className={'text-body3 text-font02'}>Referral Status</Text>
                        <WizSelectButton
                            data={statusList}
                            onChange={item => {
                                setReferralStatus(item)
                            }}
                            activeValue={referralStatus}
                            className={'mx-auto'}
                        />
                    </div>
                    <div className={'col-span-2 text-center'}>
                        <WizButton
                            onClick={async () => {
                                const {status} = await editReferral(data?.data?.id, {
                                    exchange_maker_fee_rate: exchange_maker_fee_rate,
                                    exchange_taker_fee_rate: exchange_taker_fee_rate,
                                    max_reward_rate: max_reward_rate,
                                    status: referralStatus?.id,
                                    referral_code: referral_code,
                                })

                                if (status === 200) {
                                    alert(`Complete Edit Referral`)
                                    goPayback()
                                } else {
                                    alert(`Failed Edit Referral \nError Code:${status}`)
                                }
                            }}
                            text={'Edit Referral'}
                            className={'mx-auto'}
                        />
                    </div>
                </div>
            </section>
        </PageLayout>
    )
}

export default ReferralDetailPage
